import initialState from './initialState';
import { types } from '../actions/unitActions';

export default function unitReducer(state = initialState.unit, action) {
  switch (action.type) {
    case types.LOAD_UNIT_DATA_SUCCESS:
    {
      return { ...action.unit, isActive: true };
    }
    case types.LOAD_UNIT_DATA_NOT_FOUND: {
      return { isActive: false };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/unitReducer.js